<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        GIFT CARD
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <div class="upload-img mt-5" v-if="!giftcardImg">
          <input
            type="file"
            class="hidden"
            ref="uploadImgInput"
            @change="updateCurrImg"
            accept="image/*"
          />
          <vs-button @click="$refs.uploadImgInput.click()"
            >Upload Image</vs-button
          >
        </div>
        <!-- Product Image -->
        <template v-if="giftcardImg">
          <!-- Image Container -->
          <div
            class="img-container w-64 mx-auto flex items-center justify-center"
          >
            <img :src="giftcardImg" alt="img" class="responsive" />
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button
              class="mr-4"
              type="flat"
              @click="$refs.updateImgInput.click()"
              >Update Image</vs-button
            >
            <!-- <vs-button type="flat" color="#999" @click="giftcardImg = null"
              >Remove Image</vs-button
            > -->
          </div>
        </template>

        <!-- NAME -->
        <vs-input
          label="Name"
          v-model="giftcardName"
          class="mt-5 w-full"
          name="giftcardName"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('giftcardName')">{{
          errors.first("giftcardName")
        }}</span>

        <vs-input
          v-model="giftcardDesc"
          label="Description"
          class="mt-5 w-full"
          name="giftcardDesc"
          v-validate="'required'"
        />

        <!-- CATEGORY -->
        <vs-input
          v-model="giftcardSellingPrice"
          label="Selling Price"
          class="mt-5 w-full"
          name="giftcardSellingPrice"
          v-validate="'required'"
        />

        <vs-input
          v-model="giftcardFaceVal"
          label="Face Value"
          class="mt-5 w-full"
          name="giftcardFaceVal"
          v-validate="'required'"
        />

        <span
          class="text-danger text-sm"
          v-show="errors.has('giftcardSellingPrice')"
          >{{ errors.first("giftcardSellingPrice") }}</span
        >

        <!-- ORDER STATUS -->
        <!-- <vs-input
          v-model="giftcardFaceVal"
          label="Face value"
          class="mt-5 w-full"
        /> -->

        <!-- PRICE -->
        <!-- <vs-input
          v-model="giftcardDesc"
          label="Description"
          class="mt-5 w-full"
        /> -->

        <datepicker
          type="text"
          name="validFromDate"
          placeholder="Valid From Date"
          v-model="validFromDate"
          clear-button-icon
          class="w-full mt-6 pickadate"
        >
        </datepicker>

        <datepicker
          type="text"
          name="validToDate"
          placeholder="Valid To Date"
          v-model="validToDate"
          clear-button-icon
          class="w-full mt-6 pickadate"
        >
        </datepicker>
        <!-- v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }" -->
        <!-- <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span> -->

        <vs-input v-model="giftcardTnc" label="TnC" class="mt-5 w-full" />
        <div class=" w-full md:mt-2">
          <div class="demo-alignment">
            <vs-checkbox v-model="whiteKnightPrivileged"
              >White Knight Privileged</vs-checkbox
            >
          </div>
        </div>
        <vs-input-number
          type="text"
          name="privilegeMaxRedeemCount"
          label="Privilege Max Redeem Count:"
          v-model="privilegeMaxRedeemCount"
          :disabled="whiteKnightPrivileged ? false : true"
          class="w-full mt-6"
        />
        <vs-textarea
          type="text"
          name="privilegeDesc"
          label="Privilege Description"
          v-model="privilegeDesc"
          :disabled="whiteKnightPrivileged ? false : true"
          class="w-full mt-6"
        />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
import mixin from "../../mixin";
// import confirmationDialogue from "../confirmationDialogue";

export default {
  /* created: () => {
        VeeValidate.Validator.extend('giftcardName', {
            getMessage: (field) => {return `${field} Custom validation message`},
            validate: (value) => new Promise(resolve => {
          const validCoupons = ['SUMMER2017', 'WINTER2017', 'FALL2017'];
          resolve({
              valid: value && (validCoupons.indexOf(value.toUpperCase()) > -1)
            });
        })
        })
    }, */
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    Datepicker
    // confirmationDialogue
  },
  data() {
    return {
      giftcardName: "",
      giftcardDesc: "",
      giftcardSellingPrice: "",
      giftcardFaceVal: "",
      giftcardTnc: "",
      giftcardImg: "",
      giftcardImgName: "",
      validFromDate: "",
      validToDate: "",
      whiteKnightPrivileged: true,
      privilegeMaxRedeemCount: 1,
      privilegeDesc: "",

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 240,
        wheelSpeed: 2.4
      }

      //   showConfirmation: false
    };
  },
  watch: {
    whiteKnightPrivileged() {
      if (this.whiteKnightPrivileged == true) {
        this.privilegeMaxRedeemCount = 1;
      } else {
        this.privilegeMaxRedeemCount = 0;
      }
    },
    isSidebarActive(val) {
      if (!val) return;
      console.log(Object.entries(this.data).length);
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let {
          giftcardName,
          giftcardSellingPrice,
          giftcardFaceVal,
          giftcardDesc,
          giftcardTnc,
          giftcardImg,
          giftcardImgName,
          validFromDate,
          validToDate,
          whiteKnightPrivileged,
          privilegeMaxRedeemCount,
          privilegeDesc
        } = JSON.parse(JSON.stringify(this.data));
        this.giftcardName = giftcardName;
        this.giftcardSellingPrice = giftcardSellingPrice;
        this.giftcardFaceVal = giftcardFaceVal;
        this.giftcardDesc = giftcardDesc;
        this.giftcardTnc = giftcardTnc;
        this.giftcardImg = giftcardImg;
        this.giftcardImgName = giftcardImgName;
        this.validFromDate = validFromDate;
        this.validToDate = validToDate;
        this.whiteKnightPrivileged = whiteKnightPrivileged;
        this.privilegeMaxRedeemCount = privilegeMaxRedeemCount;
        this.privilegeDesc = privilegeDesc;
        // this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  mixins: [mixin],
  computed: {
    privilegeMaxRedeemCountComputed() {
      return this.whiteKnightPrivileged ? this.privilegeMaxRedeemCount : 0;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return (
        !this.errors.any()
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    initValues() {
      if (this.giftcardFaceVal) return;
      this.giftcardName = "";
      this.giftcardSellingPrice = "";
      this.giftcardFaceVal = "";
      this.giftcardDesc = "";
      this.giftcardTnc = "";
      this.giftcardImg = "";
      this.validFromDate = "";
      this.validToDate = "";
    },
    submitData() {
      this.$vs.loading();
      this.$validator.validateAll().then(result => {
        if (result) {
          const editedGiftcard = {
            giftcardName: this.giftcardName,
            giftcardDesc: this.giftcardDesc,
            giftcardSellingPrice: parseInt(this.giftcardSellingPrice),
            giftcardFaceVal: parseInt(this.giftcardFaceVal),
            giftcardTnc: this.giftcardTnc,
            giftcardImg: this.giftcardImg,
            giftcardImgName: this.giftcardImgName,
            validFromDate: this.validFromDate,
            validToDate: this.validToDate,
            whiteKnightPrivileged: this.whiteKnightPrivileged,
            privilegeMaxRedeemCount: this.privilegeMaxRedeemCountComputed,
            privilegeDesc: this.privilegeDesc
          };
          console.log(JSON.parse(JSON.stringify(this.data)));
          let obj = JSON.parse(
            JSON.stringify({
              initialGiftcard: this.data,
              editedGiftcard: editedGiftcard
            })
          );

          this.$store.commit("giftcard/EDIT_GIFTCARD", obj);
          // this.$store.commit("emp/DEL_EMPLOYEE", "0123456789");
          /* .catch(err => {
            console.error(err);
          }); */

          //   setTimeout(() => {
          this.$vs.loading.close();
          this.$emit("closeSidebar");
          this.$vs.notify({
            color: "success",
            title: "Updated giftcard information",
            text: `${editedGiftcard.giftcardName} was successfully updated.`
          });
          this.initValues();
        }
        //   , 2000);}
      });
    },
    updateCurrImg(input) {
      console.log(input);
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.giftcardImg = e.target.result;
        };
        console.log(input.target.files[0].name);
        this.giftcardImgName = input.target.files[0].name;
        reader.readAsDataURL(input.target.files[0]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
